const URL_BASE_AZURE = 'https://armazenamentowebtron.blob.core.windows.net';
export default URL_BASE_AZURE;
